import React from "react"

export default {
  label: "About",
  title: (
    <>
      The Future
      <br />
      is Color
    </>
  ),
  body: (
    <div>
      <p>
        The Black in Design Conference, organized by the Harvard University
        Graduate School of Design African American Student Union (GSD AASU)
        recognizes the contributions of the African diaspora to the design
        fields and promotes discourse around the agency of the design profession
        to address and dismantle the institutional barriers faced by our
        communities.
      </p>
      <p>
        The 2019 Black in Design conference,{" "}
        <b>"Black Futurism: Creating a More Equitable Future"</b> explores
        pathways to liberation through a design lens, considering the historical
        past and present structural oppression of black and brown communities
        locally and internationally. The conference will demonstrate how
        designers, creatives, organizers, educators, and policymakers are
        imagining more sustainable and equitable futures for black and brown
        bodies. The conference will lead discussions and exhibitions on the
        intersection of black futurism and design, contending with the role of
        the radical imagination as we tackle complex urban problems of social
        and economic injustice. We seek to create a learning environment where
        participants collaborate, grappling with questions of equity and
        possibility, while also sharing visions for the future of black
        communities across the world. This environment gives agency to black and
        brown voices to define what a more sustainable future looks like and how
        we can collectively realize this vision."
      </p>
      <p>
        Learn more about{" "}
        <a
          href="http://www.blackindesign.org/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Black in Design Conference
        </a>
      </p>
    </div>
  ),
  info: {
    when: "October 04 — 06, 2019",
    where:
      "https://www.google.com/maps/place/Gund+Hall,+42-48+Quincy+St,+Cambridge,+MA+02138/@42.3758956,-71.1160472,17z/data=!3m1!4b1!4m5!3m4!1s0x89e377441f02db27:0x6d750185268c90fe!8m2!3d42.3758956!4d-71.1138585?hl=en-US",
    questions: "blackindesignmarketing@gmail.com",
  },
}
